import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { ApiService } from '../services/api.service';

export const viewGuard: CanActivateFn = (_route, _state) => {
  const apiService = inject(ApiService);
  const router = inject(Router);

  if (!apiService.isLoggedIn()) {
    router.navigate(['auth/login']);
    return false;
  }
  return true;
};
